import { IMovementScheduleAccount, IMovementScheduleEntries } from '@modeso/types__aumico-lib-annualreport-be';
import { IDynamicKeyValue } from '@modeso/types__aumico-lib-core-be';
import { IMovementScheduleEditableColumnHeaders } from '@modeso/types__aumico-lib-notes-be';

export interface IMovementScheduleTable {
    headers: IMovementScheduleEditableColumnHeaders;
    dataSource: IMovementScheduleAccount[];
    totalRow: IMovementScheduleEntries;
    footnotes?: string[];
}

export interface IMovementScheduleTableForm {
    headers: IMovementScheduleHeaders;
    dataSource: IMovementScheduleAccount[];
    totalRow: IMovementScheduleEntries;
    footnote: string;
}

interface IMovementScheduleHeaders {
    header1: IDynamicKeyValue;
    header2: IDynamicKeyValue;
    header3: IDynamicKeyValue;
    header4: IDynamicKeyValue;
}
